export default __webpack_public_path__ + "b04d3976922ef2029c580edce6372298.png";